import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Menu as MenuIcon } from 'lucide-react';
import { IconButton } from '../ui';
import { Wordmark } from '../brand';
import { KnowledgeScopePicker } from './KnowledgeScopePicker.jsx';

/**
 * Mobile top bar (<640px), spec §8.4: menu button, Etch mark, knowledge scope.
 * Hidden by `layout.css` at every larger breakpoint.
 *
 * @param {object} props
 * @param {boolean} props.menuOpen
 * @param {() => void} props.onOpenMenu
 */
export function TopBar({ menuOpen, onOpenMenu }) {
  const { t } = useTranslation();

  return (
    <header className="etch-app__topbar">
      <IconButton label={t('a11y.openMenu')} aria-expanded={menuOpen} onClick={onOpenMenu}>
        <MenuIcon size={20} aria-hidden="true" />
      </IconButton>

      <Link to="/" className="etch-shell-topbar__brand" aria-label={t('brandKit.name')}>
        <Wordmark size="sm" aria-hidden="true" />
      </Link>

      <KnowledgeScopePicker placement="topbar" />
    </header>
  );
}

export default TopBar;
